const tokenRefreshedListeners = new Set<() => void>();

/**
 * Register a callback to be called when the JWT access token is successfully refreshed.
 * Returns an unsubscribe function.
 */
export function onAuthTokenRefreshed(cb: () => void): () => void {
  tokenRefreshedListeners.add(cb);
  return () => {
    tokenRefreshedListeners.delete(cb);
  };
}

/**
 * Emit the token-refreshed event to all registered listeners.
 * Only called after a successful token refresh (not on initial login or failure).
 */
export function emitAuthTokenRefreshed(): void {
  for (const cb of tokenRefreshedListeners) {
    try {
      cb();
    } catch (e) {
      console.error('[auth:token-refreshed] listener error', e);
    }
  }
}

/**
 * For tests only — clears registered listeners.
 */
export function _resetAuthTokenListeners(): void {
  tokenRefreshedListeners.clear();
}
